import { render, staticRenderFns } from "./default.vue?vue&type=template&id=29b7a971&scoped=true&lang=html&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=29b7a971&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b7a971",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlatformIcon: require('/Users/grant/Dev/postpone/frontend/components/platform/Icon.vue').default,SchedulingButtons: require('/Users/grant/Dev/postpone/frontend/components/SchedulingButtons.vue').default})
